import { render, staticRenderFns } from "./SchoolCard.vue?vue&type=template&id=864d43a0&scoped=true&"
import script from "./SchoolCard.vue?vue&type=script&lang=js&"
export * from "./SchoolCard.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCard.vue?vue&type=style&index=0&id=864d43a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864d43a0",
  null
  
)

export default component.exports